import { CallApi, handleJSONResponse } from './common';
import { TourEvent } from '@common/types/traclink/tour-event';
import { NewTourEvent } from '@common/types/traclink/new-tour-event';

const callAPI = CallApi('traclink');

export const listTourEvents = async (ownerId: string): Promise<TourEvent[]> => {
  const response = await callAPI(`/tourevents/${ownerId}`, 'GET');

  return await handleJSONResponse(response);
};

export const createTourEvent = async (
  newTourEvent: NewTourEvent
): Promise<TourEvent> => {
  const response = await callAPI('/tourevents', 'POST', newTourEvent);

  return await handleJSONResponse(response);
};

export const updateTourEvent = async (
  tourEvent: TourEvent
): Promise<TourEvent> => {
  const response = await callAPI('/tourevents', 'PUT', tourEvent);

  return await handleJSONResponse(response);
};

export const deleteTourEvent = async (
  ownerId: string,
  tourEventId: string
): Promise<{ success: boolean }> => {
  const response = await callAPI(
    `/tourevents/${ownerId}/${tourEventId}`,
    'DELETE'
  );

  return await handleJSONResponse(response);
};
